import { Component, Inject } from '@angular/core';

import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

interface PreBidDialogData {
  connectionType: string;
  isShowPartnerNameForPrebid: boolean;
  isShowPartnerNameForPrebidJS: boolean;
  name: string;
  partnerName: string;
  seat: string;
  token: string;
  endpoint: string;
}

@Component({
    selector: 'app-prebid-endpoint-dialog',
    templateUrl: './prebid-endpoint-dialog.component.html',
    styleUrls: ['./prebid-endpoint-dialog.component.scss'],
    standalone: false
})
export class PrebidEndpointDialogComponent {

  constructor(
    @Inject(NZ_MODAL_DATA) public data: PreBidDialogData,
    private dialogRef: NzModalRef<PrebidEndpointDialogComponent>,
  ) { }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
